var map = {
	"./how-it-works-1.jpg": "aab0",
	"./how-it-works-2.jpg": "afdd",
	"./how-it-works-3.jpg": "eb59",
	"./how-it-works-4.jpg": "9204",
	"./product-include.png": "a141",
	"./product-inclusion.png": "00136",
	"./puppy-how-to-get.png": "bf0d",
	"./puppy-how-to-get.webp": "0da40",
	"./puppy-main-hero.png": "811d",
	"./puppy-stock-image-1.jpg": "52dc",
	"./puppy-what-we-do-1.png": "8427",
	"./puppy-what-we-do-1.webp": "514a",
	"./puppy-what-we-do.png": "ef4c",
	"./puppy-what-we-do.webp": "6f2a",
	"./webp-puppy-main-hero.webp": "b18a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "19b9";